import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../../style/attendanceContent.css";
import { PageHeader } from "../../components/admin/AdminUI";
import { SHOW_RFID_MAPPING } from "../../config/attendanceFeatures.js";
import ClassLinksCard from "./ClassLinksCard.js";

const AttendanceDashboard = ({ setLocationAdmin }) => {
  const navigate = useNavigate();
  const address = useLocation();
  const [errorMe, setErrorMe] = useState(false);
  const [currentClass, setCurrentClass] = useState("");
  const [simulatedBatch, setSimulatedBatch] = useState("");

  const getMe = async () => {
    try {
      await axios.get("/meAdmin");
    } catch (error) {
      setErrorMe(true);
    }
  };

  const getContext = async () => {
    try {
      const [currentClassRes, simulatedBatchRes] = await Promise.all([
        axios.get("/config/currentclass"),
        axios.get("/config/simulatedbatch"),
      ]);
      setCurrentClass(currentClassRes.data.currentClass || "");
      setSimulatedBatch(simulatedBatchRes.data.simulatedBatch || "");
    } catch (error) {}
  };

  useEffect(() => {
    setLocationAdmin(address);
    getMe();
    getContext();
  }, []);

  useEffect(() => {
    if (errorMe) {
      Swal.fire({
        title: "Session Expired",
        text: "Please login to your account !",
        icon: "warning",
        background: "white",
        color: "black",
        backdrop: `rgba(131, 131, 131, 0.5)`,
        showCancelButton: false,
        confirmButtonColor: "#fb3104",
        confirmButtonText: "Ok",
        customClass: { confirmButton: "custom-btn-sweetalrt" },
      });
      navigate("/loginAdmin");
    }
  }, [errorMe, navigate]);

  const shortcuts = [
    { title: "Class Sessions", desc: "Generate & atur jam 10 sesi per kelas/batch.", icon: "bi-calendar3", to: "/attendance/sessions" },
    ...(SHOW_RFID_MAPPING
      ? [{ title: "RFID Mapping", desc: "Petakan PIN mesin Fingerspot ke student.", icon: "bi-credit-card-2-front", to: "/attendance/rfid-mapping" }]
      : []),
    { title: "Attendance Grid", desc: "Lihat & override kehadiran per sesi, rekap JS/TH/PT/AG.", icon: "bi-grid-3x3", to: "/attendance/grid" },
    { title: "Assignment Grading", desc: "Nilai tugas dari Google Classroom, tulis balik nilainya.", icon: "bi-clipboard-check", to: "/attendance/grading" },
    { title: "Report & Graduation", desc: "Raport per kelas & per student, status eligible graduate.", icon: "bi-mortarboard", to: "/attendance/report" },
  ];

  return (
    <div className="adm-main">
      <PageHeader title="Attendance & Grading" subtitle="Track class sessions, attendance, assignments, and graduation." />

      <div className="adm-stats">
        <div className="adm-stat adm-stat--icon">
          <span className="adm-stat-icon">
            <i className="bi bi-journal-bookmark"></i>
          </span>
          <div>
            <p className="adm-stat-label">Current Running Class</p>
            <p className="adm-stat-value">{currentClass || "Not set"}</p>
          </div>
        </div>
        <div className="adm-stat adm-stat--icon">
          <span className="adm-stat-icon">
            <i className="bi bi-collection"></i>
          </span>
          <div>
            <p className="adm-stat-label">Current Running Batch</p>
            <p className="adm-stat-value">{simulatedBatch ? `Batch ${simulatedBatch}` : "Not set"}</p>
          </div>
        </div>
      </div>

      <p className="adm-form-section-title">Go to</p>
      <div className="adm-shortcuts">
        {shortcuts.map((s) => (
          <button key={s.to} type="button" className="adm-shortcut" onClick={() => navigate(s.to)}>
            <span className="adm-stat-icon">
              <i className={`bi ${s.icon}`}></i>
            </span>
            <span>
              <span className="adm-shortcut-title">{s.title}</span>
              <span className="adm-shortcut-desc">{s.desc}</span>
            </span>
            <i className="bi bi-chevron-right adm-shortcut-arrow"></i>
          </button>
        ))}
      </div>

      <ClassLinksCard />
    </div>
  );
};

export default AttendanceDashboard;
